import Pagination from '@mui/material/Pagination';
import { getMUICache } from '../../../common/utils';
import { CacheProvider } from '@emotion/react';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import "./PaginationTwo.css";

function Footer(props: any) {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const { type, handlePrevBtnClick, handleNextBtnClick, handlePaginationChange, paginationMetaData, handleLoadMoreClick, currentPageIndex, isNextPageDataAvailable } = props;

    const getFooterData = () => {

        if(isNextPageDataAvailable != undefined) {
            
            if (type == "page" && paginationMetaData.count > 1) {
                return <Pagination siblingCount={0} boundaryCount={1} variant="outlined" page={currentPageIndex} defaultPage={currentPageIndex} count={paginationMetaData.count} onChange={handlePaginationChange} size={isMobile ? 'small' : 'medium'}/>
            } else if (type == "next") {
                return (
                    (isNextPageDataAvailable || (!isNextPageDataAvailable && currentPageIndex != 1)) && <div className="nxpvbutton">
                        <button onClick={handlePrevBtnClick} disabled={currentPageIndex == 1}>Prev</button>
                        {<button onClick={handleNextBtnClick} disabled={!isNextPageDataAvailable}>Next</button>}
                    </div>
                )
            } else if (type == "load") {
                return isNextPageDataAvailable && <div className="lodemorecontent" onClick={handleLoadMoreClick}><button>Load More</button></div>
            }
        }
        else {
            if (type == "page" && paginationMetaData.count > 1) {
                return <Pagination siblingCount={0} boundaryCount={1} variant="outlined" page={currentPageIndex} defaultPage={currentPageIndex} count={paginationMetaData.count} onChange={handlePaginationChange} size={isMobile ? 'small' : 'medium'}/>
            } else if (type == "next" && paginationMetaData.count > 1) {
                return (
                    <div className="nxpvbutton">
                        <button onClick={handlePrevBtnClick} disabled={currentPageIndex == 1}>Prev</button>
                        <button onClick={handleNextBtnClick} disabled={currentPageIndex == paginationMetaData.count}>Next</button>
                    </div>
                )
            } else if (type == "load" && paginationMetaData.count > 1 && currentPageIndex != paginationMetaData.count) {
                return <div className="lodemorecontent" onClick={handleLoadMoreClick}><button>Load More</button></div>
            }
        }
    }

    return (
        <CacheProvider value={getMUICache()}>
            <div className="pagination">
                {getFooterData()}
            </div>
        </CacheProvider>
    )
}

export default Footer;